import apiClient from './client';

const customFieldsApi = {
  list: async (entityType = null) => {
    const response = await apiClient.get('/api/v1/custom-fields', {
      params: entityType ? { entity_type: entityType, active_only: true } : { active_only: true }
    });
    return response.data || [];
  },

  getValues: async (entityType, entityId) => {
    const response = await apiClient.get(`/api/v1/custom-fields/values/${entityType}/${entityId}`);
    return response.data || [];
  },

  setValues: async (entityType, entityId, values) => {
    const response = await apiClient.post(`/api/v1/custom-fields/values/${entityType}/${entityId}`, values);
    return response.data;
  }
};

export default customFieldsApi;
